import 'react-quill/dist/quill.snow.css'
import PolicyEditor from '../../../Utilities/PolicyEditor'

const TermsAndConditions = () => {
  return (
    <PolicyEditor title="Terms and Conditions" fieldKey="termsAndConditions" />
  )
}

export default TermsAndConditions
